export default "__VITE_ASSET__DnG8IDc7__"